import { render, staticRenderFns } from "./specialized-new-zone-solution.vue?vue&type=template&id=435a6479&scoped=true"
import script from "./specialized-new-zone-solution.vue?vue&type=script&lang=js"
export * from "./specialized-new-zone-solution.vue?vue&type=script&lang=js"
import style0 from "./specialized-new-zone-solution.vue?vue&type=style&index=0&id=435a6479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435a6479",
  null
  
)

export default component.exports